(function () {
  'use strict';

  var picker = document.querySelector('[data-cc-zodiac-picker]');
  if (!picker) return;

  // data-label carries the property_name so the ATC gate reads "ADD ZODIAC TO
  // CONTINUE" (a noun) rather than the instructional heading.
  var gateLabel = picker.dataset.label || 'Zodiac';
  var property = picker.dataset.property || 'Zodiac';
  var required = picker.hasAttribute('data-required');

  var slotsContainer = picker.querySelector('[data-cc-slots]');
  var panel = picker.querySelector('[data-cc-sign-panel]');
  var removeBtn = picker.querySelector('[data-cc-remove-btn]');
  var hiddenInput = picker.querySelector('[data-cc-zodiac-input]');

  // Single-select only: exactly one slot, no count selector, no price impact.
  // Grid behavior mirrors the single-slot birthflower path — visible while the
  // slot is empty, picking fills it and CLOSES the grid, tapping the filled slot
  // REOPENS the grid, picking again closes it. No outside-click dismiss.
  var chosen = null;   // { sign, abbrev, name } or null
  var gridOpen = true; // starts open on the single empty slot

  function findCell(sign) {
    return panel.querySelector('[data-cc-sign][data-sign="' + sign + '"]');
  }

  // Property contract: properties[<property>] = the chosen sign name (empty
  // until picked). Event filled === 1 only once a sign is chosen, 0 otherwise,
  // so the switcher's gate keeps ATC disabled while empty. Fires once on init.
  function emit() {
    var filled = chosen ? 1 : 0;
    hiddenInput.value = chosen ? chosen.name : '';

    document.dispatchEvent(new CustomEvent('cc:zodiac-changed', {
      detail: {
        property: property,
        label: gateLabel,
        filled: filled,
        min: 1,
        required: required,
        value: chosen ? chosen.name : ''
      }
    }));
  }

  function renderSlot() {
    slotsContainer.innerHTML = '';

    var slot = document.createElement('button');
    slot.type = 'button';
    slot.dataset.index = 0;

    if (chosen) {
      slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--filled';
      if (gridOpen) slot.className += ' is-editing';
      slot.setAttribute('aria-label', chosen.name + '. Tap to change or remove.');

      // Clone the swatch image from the panel cell — single source of truth for
      // src/srcset/sizes/alt lives in the snippet markup, not duplicated here.
      var cell = findCell(chosen.sign);
      var cellImgs = cell ? cell.querySelectorAll('img') : [];
      cellImgs.forEach(function (cellImg) {
        var slotImg = cellImg.cloneNode(true);
        slotImg.className = 'cc-birthstone-picker__slot-img';
        slotImg.removeAttribute('loading');
        slot.appendChild(slotImg);
      });

      // Zodiac selected chip is image-only — no abbreviation/name text over the
      // sign image. The sign is still announced to screen readers via the slot's
      // aria-label above. (Birthstone/birthflower slots keep their own labels;
      // this is the zodiac picker's own JS.)
    } else {
      slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--active is-editing';
      slot.setAttribute('aria-label', 'Empty slot. Tap to choose your sign.');
    }

    slot.addEventListener('click', function (e) { e.stopPropagation(); reopen(); });
    slotsContainer.appendChild(slot);
  }

  function render() {
    renderSlot();

    // Panel shows while gridOpen; closes once a sign is picked.
    panel.hidden = !gridOpen;
    // Gold remove/clear only shows when the slot holds a sign.
    removeBtn.hidden = !chosen;

    // Highlight the panel cell matching the chosen sign.
    panel.querySelectorAll('[data-cc-sign]').forEach(function (cell) {
      cell.classList.toggle('is-selected', !!chosen && chosen.sign === cell.dataset.sign);
    });

    emit();
  }

  // Tapping the slot (filled or empty) reopens the grid to (re)pick.
  function reopen() {
    gridOpen = true;
    render();
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  panel.querySelectorAll('[data-cc-sign]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      chosen = {
        sign: this.dataset.sign,
        abbrev: this.dataset.abbrev,
        name: this.dataset.name
      };
      gridOpen = false; // picking closes the grid
      render();
    });
  });

  removeBtn.addEventListener('click', function () {
    // Clears the slot back to empty and reopens the grid for a re-pick.
    if (chosen) {
      chosen = null;
      gridOpen = true;
      render();
    }
  });

  // Fire once on init: empty slot, grid open, gate seeded before interaction.
  render();
})();
